<template>
  <div>
    <form class="form-horizontal">
      <input type="hidden" name="id" id="id"/>
      <div class="form-group lp-flex-box" :class="{'has-error': biz.description==''}" style='align:left'>
          <label class="control-label col-sm-3">名称</label>
          <div class="controls col-sm-8">
              <input type="text" name="description" id="description" v-model="biz.description" class="form-control" />
          </div>
          <span class="help-inline">必填</span>
      </div>
      <div class="form-group lp-flex-box" :class="{'has-error': biz.name==''}" style='align:left'>
          <label class="control-label col-sm-3">编码</label>
          <div class="controls col-sm-8">
              <input type="text" name="name" id="name" v-model="biz.name" class="form-control input-sm" />
          </div>
          <span class="help-inline">必填</span> 
      </div>
      <div class="form-group lp-flex-box" style='align:left'>
          <label class="control-label col-sm-3">权限</label>
          <div class="controls col-sm-8" style="max-height:300px;overflow-y:scroll">
              <table class="table table-striped table-hover table-bordered table-condensed">
                <thead>
                  <tr>
                    <th width="30%">选中权限<input type="checkbox" id="check-all" @click="checkAll" :checked="ui.checkedAll ? checked : ''"></th>
                    <th class="text_overflow">权限名称</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in biz.items">
                    <td style="vertical-align:middle" class="text_overflow"><input type="checkbox" :data-id="item.id" @click="check"></td>
                    <td style="vertical-align:middle" class="text_overflow">{{item.name}}</td>
                  </tr>
                </tbody>
              </table>
          </div>
          <span class="help-inline">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> 
      </div>
      <div class="form-group lp-flex-box" style='align:left'>
        <button class="btn" type="button" @click="close">取消</button>
        <button class="btn green" type="button" @click="save">确定</button>
      </div>
    </form>
  </div>
</template>

<script>
import http from '../../lib/utils/request.js'
import commonMethods from '../../lib/methods/common.js'
import mixins from '../../mixins/index'
import {MSG_ID} from '../../lib/constant.js'
export default {
  name: 'roleedit',
  mixins: mixins,
  data () {
    return {
      biz: {
        id: 0,
        name: '',
        description: '',
        items: [],
        permissionIds: []
      },
      ui: {
        checkedAll: false
      }
    }
  },
  methods: {
    load () {
      if (this.biz.id) {
        this.loadRole()
      }
      this.loadPermission()
    },
    loadRole () {
      if (this.biz.id) {
        http.invoke('auth.pageRole', {account: this.uid(), id: this.biz.id, page_index: 1, page_size: 1}, (data) => {
          let role = data.content && data.content[0]
          if (role) {
            this.biz.id = role.id
            this.biz.name = role.name
            this.biz.description = role.description
            this.biz.permissionIds = data.ext.permission_ids
          }
        })
      }
    },
    loadPermission () {
      http.invoke('auth.pagePermission', {account: this.uid(), page_index: 1, page_size: 500}, (data) => {
        this.biz.items = data.content
        setTimeout(() => {
          if (!this.biz.permissionIds || this.biz.permissionIds.length === 0) {
            return
          }
          window.$(this.$el).find('input[type="checkbox"]').each((idx, elem) => {
            // console.log(elem.dataset.id, this.biz.permissionIds.indexOf(+elem.dataset.id) > -1)
            if (elem.dataset.id && this.biz.permissionIds.indexOf(+elem.dataset.id) > -1) {
              elem.checked = true
            }
          })
        }, 1000)
      })
    },
    onShowInModal (...args) {
      let options = args[0]
      this.biz.id = +options['id']
      this.load()
    },
    onHideInModal (...args) {
      this.biz.id = 0
      this.name = ''
      this.description = ''
      this.permissionIds = []
    },
    save () {
      if (!this.biz.name || !this.biz.description) {
        return
      }
      let permIds = []
      window.$(this.$el).find('input[type="checkbox"]:checked').not('#check-all').each((idx, el) => {
        permIds.push(el.dataset.id)
      })
      this.biz.permissionIds = permIds
      console.log(this.biz.permissionIds)
      let reqdata = {action: 1, name: this.biz.name, id: this.biz.id, description: this.biz.description, permission_ids: this.biz.permissionIds}
      http.invoke('auth.setRole', reqdata, (data) => {
        window.emitter.emit(MSG_ID.MSG_UI_HIDE_MODAL)
        window.emitter.emit(MSG_ID.MSG_ROLE_SET_SUCCESS)
      })
    },
    close () {
      window.emitter.emit(MSG_ID.MSG_UI_HIDE_MODAL)
    },
    checkAll (event) {
      let $ck = window.$(event.target)
      let checked = $ck.prop('checked')
      $ck.closest('table').find('input[type="checkbox"]').prop('checked', checked)
    },
    check (event) {
      let status = new Set()
      window.$(event.target).closest('table').find('input[type="checkbox"]').not('#check-all').each((idx, item) => {
        status.add(item.checked)
      })
      if (status.size === 1) {
        window.$('#check-all').prop('checked', status.values().next().value)
      } else {
        window.$('#check-all').prop('checked', false)
      }
    },
    ...commonMethods
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  color: #42b983;
}
@media screen and (max-width: 767px) {
  .mh {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// RoleEdit.vue?08b17500